import { UserListFilterType } from '../../types/types';

const getUserListFilterType = (store: any): UserListFilterType => {
  return store.userFilter;
};

export default { getUserListFilterType };
